import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { IStateProps } from '../types';
// import { RootState, AppDispatch } from '~/store/store';

// export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<IStateProps> = useSelector;
